import ActionConstants from "../action-constants";
import { createReducer } from "../utils/redux-util";
import Reducer from "./reducer";

class ApuOrderApiReducer extends Reducer {

  static setApuOrderData(state, action) {
    return {
      ...state,
      apuOrderDetails: {
        data: action.payload,
      },
    };
  }
}

const apuOrderApiActionHandlers = {
  [ActionConstants.APU_ORDER_DATA]: ApuOrderApiReducer.setApuOrderData,
};

const initialState = {
  apuOrderDetails: {
    data: {},
  },
};

export const apuOrderDetails = createReducer(
  initialState,
  apuOrderApiActionHandlers
);
